module.exports = __webpack_public_path__ + "teg/media/Exim.22fb9581.jpg";